// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging"; // <--- 1. Import this

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCP9iGOixEPMRYA_D5o8QrIKMZ9vQOhS-k",
  authDomain: "true-education-app-v2.firebaseapp.com",
  projectId: "true-education-app-v2",
  storageBucket: "true-education-app-v2.firebasestorage.app",
  messagingSenderId: "484330417863",
  appId: "1:484330417863:web:c707cc145befc52c6a98e2",
  measurementId: "G-5B1GQHX1SJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get references to the services we need
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);
const messaging = getMessaging(app); // <--- 2. Initialize Messaging

// Export them for use in your app
export { auth, db, functions, storage, messaging }; // <--- 3. Add messaging to export